import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class SpeakerItem extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'SpeakerItem';

    // Define default properties here
    static instanceDefaults() {
        return {
            photo: null,
            name: null,
            title: null,
            company: null,
            bio: '',
            speaks_at: '',
            
            name__sc: null,
            title__sc: null,
            company__sc: null,
            bio__sc: '',
            speaks_at__sc: '',
            
            name__tc: null,
            title__tc: null,
            company__tc: null,
            bio__tc: '',
            speaks_at__tc: '',
            
            name__id: null,
            title__id: null,
            company__id: null,
            bio__id: '',
            speaks_at__id: '',
            
            name__vn: null,
            title__vn: null,
            company__vn: null,
            bio__vn: '',
            speaks_at__vn: '',
            
            order: -1,
        }
    }
}

const servicePath = 'f-speaker-people';
const servicePlugin = makeServicePlugin({
    Model: SpeakerItem,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin